import React from 'react'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import Colorpicker from 'blocks.simple/colorpicker/colorpicker'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import EditText from 'blocks.simple/editText/editText'
import template from 'es6-template-strings'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { Button } from 'molecules/Button'
import { gridSizeOptions } from '../templateEditor.data'
import { useTemplateEditorContext } from '../hooks/templateEditorContext'
import { inspectorFieldStyles as styles } from './templateEditor__inspector.jcss'
import { TemplateEditorNumberStepper } from './templateEditor__numberStepper'

export const TemplateEditorInspectorCanvasSettings = () => {
    const {
        canvasW,
        canvasH,
        canvasBg,
        canvasBgMedia,
        showGrid,
        gridSize,
        setCanvasBg,
        setCanvasBackgroundMedia,
        setCanvasSize,
        setShowGrid,
        setGridSize,
        swapOrientation,
        clearCanvas,
        theme,
    } = useTemplateEditorContext()

    return (
        <>
            <div className={styles.fieldGroup}>
                <div className={styles.fieldGroupLabel}>{translate('templateEditorCanvasSize')}</div>
                <div className={styles.fieldRow}>
                    <TemplateEditorNumberStepper
                        label={translate('templateEditorWidthShort')}
                        value={canvasW}
                        min={theme.minCanvasSize}
                        onChange={(w) => setCanvasSize(w, canvasH)}
                    />
                    <TemplateEditorNumberStepper
                        label={translate('templateEditorHeightShort')}
                        value={canvasH}
                        min={theme.minCanvasSize}
                        onChange={(h) => setCanvasSize(canvasW, h)}
                    />
                </div>
                <Button
                    className={cn(styles.actionButtonFull, styles.orientationButton)}
                    mod="default"
                    size="s"
                    onClick={swapOrientation}
                >
                    {translate('templateEditorOrientation')}
                </Button>
            </div>

            <div className={styles.fieldGroup}>
                <div className={styles.fieldGroupLabel}>{translate('templateEditorBackground')}</div>
                {canvasBgMedia && (
                    <div className={styles.bgMediaPreview}>
                        {canvasBgMedia.fileType === 'image' ? (
                            <img
                                className={styles.bgMediaPreviewImage}
                                src={canvasBgMedia.thumbnail || canvasBgMedia.src}
                                alt=""
                            />
                        ) : (
                            <video
                                className={styles.bgMediaPreviewImage}
                                src={canvasBgMedia.src}
                                poster={canvasBgMedia.thumbnail}
                                muted
                            />
                        )}
                        <span className={styles.bgMediaPreviewName}>{canvasBgMedia.name}</span>
                        <Button
                            className={styles.actionButtonFull}
                            mod="default"
                            size="s"
                            onClick={() => setCanvasBackgroundMedia(null)}
                        >
                            {translate('templateEditorRemoveBackground')}
                        </Button>
                    </div>
                )}
                <div className={styles.fieldRow}>
                    <Colorpicker color={canvasBg} onChange={setCanvasBg} disabled={Boolean(canvasBgMedia)} />
                    <EditText
                        value={canvasBg}
                        onChange={setCanvasBg}
                        rounded="full_mini"
                        readOnly={Boolean(canvasBgMedia)}
                    />
                </div>
            </div>

            <div className={styles.fieldGroup}>
                <div className={styles.fieldGroupLabel}>{translate('templateEditorGrid')}</div>
                <Checkbox
                    label={translate('templateEditorShowGrid')}
                    checked={showGrid}
                    onClick={() => setShowGrid(!showGrid)}
                />
                <div className={cn(styles.fieldRow, styles.fieldRowSpaced)}>
                    <Dropdown
                        label={translate('templateEditorGridStep')}
                        options={gridSizeOptions.map((size) => ({
                            id: String(size),
                            name: template(translate('templateEditorGridSizePx'), { size }),
                        }))}
                        value={String(gridSize)}
                        onChange={(option) => setGridSize(Number(option.id))}
                    />
                </div>
            </div>

            <div className={styles.fieldGroup}>
                <Button className={styles.actionButtonFull} mod="default" size="s" onClick={clearCanvas}>
                    {translate('templateEditorClearCanvas')}
                </Button>
            </div>
        </>
    )
}
